import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CiLocationArrow1 } from "react-icons/ci";
import { LuArrowRightLeft, LuHotel } from "react-icons/lu";
import { MdFlightTakeoff } from "react-icons/md";
import Navbarsticky from "./NavbarSticky";
import Footer from "./Footer";

import {
  getcarrentalPackageList,
  pickupdropprice,
} from "../store/slices/carrentalpackage";
import { getPlacesList } from "../store/slices/hotel";
import { useDispatch, useSelector } from "react-redux";
import img1 from "../assets/img/hoteldetails-img1.png";
import { Container, Row, Col, Tab, Tabs, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import Travelfeedback from "./Travelfeedback";
import Traveldestination from "./dreamDiv";

const CarRental = () => {
  const getISTDateTime = () => {
    const now = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    return new Date(now.getTime() + istOffset).toISOString().slice(0, 16);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // TAB state
  const [activeTab, setActiveTab] = useState("airport");

  // Form states
  const [placeInput, setPlaceInput] = useState("");
  const [isSwapped, setIsSwapped] = useState(false);
  const [selectedPlaceId, setSelectedPlaceId] = useState(null);
  const [isPlaceSelected, setIsPlaceSelected] = useState(false);
  const [filteredPlaces, setFilteredPlaces] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [carpackages, setcarpackages] = useState([]);
  const [duration, setDuration] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [hotelName, setHotelName] = useState("");
  const [pickupDate, setpickupDate] = useState("");
  const [allDropPlaces, setAllDropPlaces] = useState([]);

  const [toPlace, settoPlace] = useState("");
  const [fromPlace, setfromPlace] = useState("");
  const [toPlaceId, settoPlaceId] = useState("");
  const [fromPlaceId, setfromPlaceId] = useState("");
  const [filteredPickupPlaces, setFilteredPickupPlaces] = useState([]);
  const [filteredDropPlaces, setFilteredDropPlaces] = useState([]);
  const [showPickupSuggestions, setShowPickupSuggestions] = useState(false);
  const [showDropSuggestions, setShowDropSuggestions] = useState(false);

  const places = useSelector((state) => state.hotel?.places?.placesData ?? []);

  // Fetch packages
  const getPackages = () => {
    let item = { limit: 4 };
    dispatch(getcarrentalPackageList(item))
      .unwrap()
      .then((data) => {
        setcarpackages(data?.carrentalpackages?.packageData);
      })
      .catch(({ message }) => console.error(message));
  };

  useEffect(() => {
    getPackages();
  }, []);

  // Fetch places based on active tab (visibility)
  useEffect(() => {
    const visibility =
      activeTab === "airport"
        ? "Airport"
        : activeTab === "pickupdrop"
        ? "Pickup Drop"
        : "Hourly";

    dispatch(getPlacesList({ visibility }))
      .unwrap()
      .catch((err) => console.error("Error fetching places:", err));
  }, [activeTab, dispatch]);

  // Airport
  const handlePlaceChange = (event) => {
    if (isPlaceSelected) return;
    const inputValue = event.target.value;
    setPlaceInput(inputValue);
    if (inputValue.length > 1) {
      const filtered = places.filter((place) =>
        place.name?.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredPlaces(filtered);
      setShowSuggestions(filtered.length > 0);
    } else {
      setShowSuggestions(false);
    }
  };

  const handleInputFocus = () => {
    setSelectedPlaceId(null);
    setIsPlaceSelected(false);
    setFilteredPlaces(places);
    setShowSuggestions(true);
  };

  const handleSelectPlace = (place) => {
    setPlaceInput(place.name);
    setSelectedPlaceId(place._id);
    setShowSuggestions(false);
    setIsPlaceSelected(true);
  };

  const interchangeRoute = () => setIsSwapped((prev) => !prev);

  const handleAirportSubmit = (event) => {
    event.preventDefault();

    if (!placeInput || !selectedPlaceId || !hotelName || !pickupDate) {
      alert("Please fill all required fields!");
      return;
    }

    const queryParams = new URLSearchParams({
      placeName: placeInput,
      placeId: selectedPlaceId,
      hotelName: hotelName,
      pickupDate: pickupDate,
      isSwapped: isSwapped ? "true" : "false",
    }).toString();

    navigate(`/airport-car-booking?${queryParams}`);
  };

  // Pickup / Drop
  const handlePickupChange = (event) => {
    const input = event.target.value;
    setfromPlace(input);

    if (input.length > 1) {
      const filtered = places.filter((place) =>
        place.name.toLowerCase().includes(input.toLowerCase())
      );
      setFilteredPickupPlaces(filtered);
      setShowPickupSuggestions(true);
    } else {
      setShowPickupSuggestions(false);
    }
  };

  const handleSelectPickup = (place) => {
    setfromPlace(place.name);
    setfromPlaceId(place._id);
    setShowPickupSuggestions(false);

    dispatch(pickupdropprice(place._id))
      .unwrap()
      .then((data) => {
        const drops =
          data?.pickupdropprice?.data?.map((item) => item.toPlace) ?? [];
        setAllDropPlaces(drops);
        setFilteredDropPlaces(drops);
      });
  };

  const handleDropChange = (event) => {
    const inputValue = event.target.value;
    settoPlace(inputValue);

    if (inputValue.length > 0) {
      const filtered = allDropPlaces.filter((place) =>
        place.name.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredDropPlaces(filtered);
    }
  };

  const handleSelectDrop = (place) => {
    settoPlace(place.name);
    settoPlaceId(place._id);
    setShowDropSuggestions(false);
  };

  const handlepickupSubmit = (event) => {
    event.preventDefault();

    if (
      !fromPlace ||
      !toPlace ||
      !fromPlaceId ||
      !toPlaceId ||
      !hotelName ||
      !pickupDate
    ) {
      alert("Please fill all fields");
      return;
    }

    if (fromPlace.trim().toLowerCase() === toPlace.trim().toLowerCase()) {
      alert("Pickup and Drop locations cannot be same");
      return;
    }

    const queryParams = new URLSearchParams({
      fromPlace,
      toPlace,
      hotelName,
      pickupDate,
      fromPlaceId,
      toPlaceId,
    }).toString();

    navigate(`/pickup-drop?${queryParams}`);
  };

  // Hourly
  const handleSubmit = (event) => {
    event.preventDefault();
    if (!duration || !date || !time) return;

    navigate(
      `/hourly-car-booking?duration=${duration}&date=${date}&time=${time}`
    );
  };

  // Dummy tours
  const tours = [
    {
      id: 1,
      title: "One Day Car Rental",
      location: "Port Blair",
      days: "7 Days",
      price: "Rs. 32000",
      rating: 5,
      img: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800",
    },
  ];

  return (
    <>
      <Navbarsticky />

      <div className="carrental-container pt-100 rel z-2 car-ui-wrapper">
        <div className="form-container">
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-3 destinations-nav mt-10"
          >
            {/* ------------------- AIRPORT TAB ------------------- */}
            <Tab eventKey="airport" title="Airport Pickup/ Drop">
              <form onSubmit={handleAirportSubmit}>
                <div className="row align-items-center">
                  {!isSwapped ? (
                    <>
                      <div className="col-md-5">
                        <div className="input-container">
                          <CiLocationArrow1 className="input-icon" />
                          <input
                            type="text"
                            placeholder="Enter pickup location"
                            value={placeInput}
                            onChange={handlePlaceChange}
                            onFocus={handleInputFocus}
                            autoComplete="off"
                            style={{ marginTop: "10px" }}
                          />
                          <label>Pickup Location</label>

                          {showSuggestions && filteredPlaces.length > 0 && (
                            <ul className="suggestion-list">
                              {filteredPlaces.map((place) => (
                                <li
                                  key={place._id}
                                  onClick={() => handleSelectPlace(place)}
                                >
                                  {place.name}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>

                      <div className="col-md-2 d-flex justify-content-center align-items-center">
                        <div
                          className="swap-icon-container"
                          onClick={interchangeRoute}
                        >
                          <LuArrowRightLeft className="swap-icon" />
                        </div>
                      </div>

                      <div className="col-md-5">
                        <div className="input-container">
                          <MdFlightTakeoff className="input-icon" />
                          <input
                            type="text"
                            value="Airport"
                            readOnly
                            style={{ marginTop: "10px" }}
                          />
                          <label>Drop Location</label>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-md-5">
                        <div className="input-container">
                          <MdFlightTakeoff className="input-icon" />
                          <input
                            type="text"
                            value="Airport"
                            readOnly
                            style={{ marginTop: "10px" }}
                          />
                          <label>Pickup Location</label>
                        </div>
                      </div>

                      <div className="col-md-2 d-flex justify-content-center align-items-center">
                        <div
                          className="swap-icon-container"
                          onClick={interchangeRoute}
                        >
                          <LuArrowRightLeft className="swap-icon" />
                        </div>
                      </div>

                      <div className="col-md-5">
                        <div className="input-container">
                          <CiLocationArrow1 className="input-icon" />
                          <input
                            type="text"
                            placeholder="Enter drop location"
                            value={placeInput}
                            onChange={handlePlaceChange}
                            onFocus={handleInputFocus}
                            autoComplete="off"
                            style={{ marginTop: "10px" }}
                          />
                          <label>Drop Location</label>

                          {showSuggestions && filteredPlaces.length > 0 && (
                            <ul className="suggestion-list">
                              {filteredPlaces.map((place) => (
                                <li
                                  key={place._id}
                                  onClick={() => handleSelectPlace(place)}
                                >
                                  {place.name}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  <div className="col-md-6">
                    <div className="input-container">
                      <LuHotel className="input-icon" />
                      <input
                        type="text"
                        placeholder="Enter hotel name"
                        value={hotelName}
                        onChange={(e) => setHotelName(e.target.value)}
                        autoComplete="off"
                        style={{ marginTop: "10px" }}
                      />
                      <label>Hotel Name</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="input-container">
                      <input
                        type="datetime-local"
                        onChange={(e) => setpickupDate(e.target.value)}
                        min={getISTDateTime()}
                        style={{ marginTop: "10px" }}
                      />
                      <label>Pickup Date Time</label>
                    </div>
                  </div>
                </div>

                <div className="text-center">
                  <button type="submit" className="take-tour-btn mt-4">
                    Search <i className="bi bi-arrow-right ms-2" />
                  </button>
                </div>
              </form>
            </Tab>

            {/* ---------------- PICKUP DROP TAB ---------------- */}
            <Tab eventKey="pickupdrop" title="Pickup / Drop">
              <form onSubmit={handlepickupSubmit}>
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="input-container">
                      <CiLocationArrow1 className="input-icon" />
                      <input
                        type="text"
                        placeholder="Enter pickup location"
                        value={fromPlace}
                        onChange={handlePickupChange}
                        onFocus={() => setShowPickupSuggestions(true)}
                        autoComplete="off"
                        style={{ marginTop: "10px" }}
                      />
                      <label>Pickup Location</label>

                      {showPickupSuggestions &&
                        filteredPickupPlaces.length > 0 && (
                          <ul className="suggestion-list">
                            {filteredPickupPlaces.map((place) => (
                              <li
                                key={place._id}
                                onClick={() => handleSelectPickup(place)}
                              >
                                {place.name}
                              </li>
                            ))}
                          </ul>
                        )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="input-container">
                      <CiLocationArrow1 className="input-icon" />
                      <input
                        type="text"
                        placeholder="Enter drop location"
                        value={toPlace}
                        onChange={handleDropChange}
                        onFocus={() => {
                          setFilteredDropPlaces(allDropPlaces);
                          setShowDropSuggestions(true);
                        }}
                        autoComplete="off"
                        style={{ marginTop: "10px" }}
                      />
                      <label>Drop Location</label>

                      {showDropSuggestions && filteredDropPlaces.length > 0 && (
                        <ul className="suggestion-list">
                          {filteredDropPlaces.map((place) => (
                            <li
                              key={place._id}
                              onClick={() => handleSelectDrop(place)}
                            >
                              {place.name}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="input-container">
                      <LuHotel className="input-icon" />
                      <input
                        type="text"
                        placeholder="Enter hotel name"
                        value={hotelName}
                        onChange={(e) => setHotelName(e.target.value)}
                        autoComplete="off"
                        style={{ marginTop: "10px" }}
                      />
                      <label>Hotel Name</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="input-container">
                      <input
                        type="datetime-local"
                        value={pickupDate}
                        onChange={(e) => setpickupDate(e.target.value)}
                        min={getISTDateTime()}
                        style={{ marginTop: "10px" }}
                      />
                      <label>Pickup Date & Time</label>
                    </div>
                  </div>
                </div>

                <div className="text-center">
                  <button type="submit" className="take-tour-btn mt-4">
                    Search <i className="bi bi-arrow-right ms-2" />
                  </button>
                </div>
              </form>
            </Tab>

            {/* ------------------- HOURLY TAB ------------------- */}
            <Tab eventKey="hourly" title="Hourly Basis">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="input-container">
                      <select
                        name="duration"
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                        style={{
                          border: "solid 1px grey",
                          borderRadius: "10px",
                          marginTop: "10px",
                        }}
                      >
                        <option value="">Select Duration</option>
                        <option value="4 Hours">4 Hours</option>
                        <option value="5 Hours">5 Hours</option>
                        <option value="8 Hours">8 Hours</option>
                        <option value="10 Hours">10 hours</option>
                        <option value="12 Hours">12 Hours</option>
                      </select>
                      <label>Duration</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="input-container">
                      <input
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        min={new Date().toISOString().split("T")[0]}
                        style={{ marginTop: "10px" }}
                      />

                      <label>Pickup Date</label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="input-container">
                      <input
                        type="time"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                        style={{ marginTop: "10px" }}
                      />
                      <label>Pickup Time</label>
                    </div>
                  </div>
                </div>

                <div className="text-center">
                  <button type="submit" className="take-tour-btn mt-4">
                    Search <i className="bi bi-arrow-right ms-2" />
                  </button>
                </div>
              </form>
            </Tab>
          </Tabs>
        </div>
      </div>

      {/* Rental packages */}
      <section className="tour-packages-section pt-3 pb-1 container-fluid">
        <Container style={{ marginBottom: "5rem", marginTop: "2rem" }}>
          <div className="text-center mb-4">
            <h2 className="mt-3 new-font">Popular Car Rental Packages</h2>
            <h2 className="fw-bold mb-4">Explore Andaman With Us</h2>

            <Row className="g-2 g-lg-4 mt-2">
              {carpackages.map((tour) => (
                <Col xs={6} sm={6} md={6} lg={4} xl={3} key={tour.id}>
                  <Link to={`/car-package-details/${tour.slug}`}>
                    <Card className="tour-card shadow-sm border-0">
                      <div className="tour-image-wrapper">
                        <img
                          src={tour.images[0]?.mediaLink}
                          className="tour-img"
                          alt=""
                        />
                      </div>

                      <Card.Body>
                        <p className="pkg-title">{tour.packageName}</p>

                        <Card.Text className="text-muted text-start">
                          <i className="bi bi-geo-alt-fill text-primary me-1"></i>
                          {(() => {
                            const placeNames =
                              tour.places?.map((p) => p.name) || [];
                            const firstTwo = placeNames.slice(0, 2).join(", ");
                            const rest =
                              placeNames.length > 2
                                ? ` + ${placeNames.length - 2} more places`
                                : "";
                            return firstTwo + rest;
                          })()}
                        </Card.Text>

                        {/* <div className="card-footer-section d-flex">
                          <div className="price-box">
                            <span className="price">{tour.price}</span>
                            <span className="per-person">/Person</span>
                          </div>

                          <div className="rating d-flex align-items-center">
                            <i className="bi bi-star-fill text-warning me-1"></i>
                            <span className="text-muted">
                              ({tour.rating} Reviews)
                            </span>
                          </div>
                        </div> */}
                      </Card.Body>
                    </Card>
                  </Link>
                </Col>
              ))}
            </Row>

            <div className="text-center explorepackage-btn-section mt-4">
              <Link to="/car-rental-package" className="more-btn">
                Explore More Packages →
              </Link>
            </div>
          </div>
        </Container>
      </section>

      <Travelfeedback />
      <Footer />
    </>
  );
};

export default CarRental;
